import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocationsCacheContext } from '../../../context/LocationsCacheContext';
import { mapFeature, mapThermostatLabelsToPtBR } from '../utils/mapping';
import { sortByAccessAndType } from '../utils/sorting';
import {
  filterSensorsForActuator,
  findItemWithId,
} from '../../../pages/Facilities/utils';
import { flatMapFeatures } from '../../../utils/actuatorUtils';

export const useActuatorFeatures = (actuatorId, defaultExposes) => {
  const { i18n } = useTranslation();
  const { sensors, actuators } = useLocationsCacheContext();
  const actuatorFromAssetCache = useMemo(
    () => findItemWithId(actuators, actuatorId) ?? null,
    [actuators, actuatorId],
  );
  const actuatorSensors = useMemo(
    () => filterSensorsForActuator(sensors, actuatorId),
    [actuatorId, sensors],
  );

  const exposes = actuatorFromAssetCache?.exposes ?? defaultExposes;

  const flatMappedFeatures = exposes
    .flatMap(flatMapFeatures)
    .map(feat => mapFeature(feat, actuatorSensors))
    .sort(sortByAccessAndType);

  return useMemo(() => {
    if (
      i18n.language === 'pt-BR' &&
      actuatorSensors.every(s => s.id.includes('Thermostat_'))
    )
      return flatMappedFeatures.map(mapThermostatLabelsToPtBR);
    return flatMappedFeatures;
  }, [i18n.language, actuatorSensors, flatMappedFeatures]);
};
